import React from 'react'
import { ReactComponent as AIIcon } from 'components/UI/icons/ai-icon.svg'
import { ReactComponent as AIIconSm } from 'components/UI/icons/ai-icon-sm.svg'
import styles from './AIButton.module.scss'

const AIButton = ({ onClick }) => {
  return (
    <>
      <div className={styles.aiButton} onClick={onClick}>
        <div className={styles.aiIconLg}>
          <AIIcon />
        </div>
        <div className={styles.aiIconSm}>
          <AIIconSm />
        </div>
      </div>
    </>
  )
}

export default AIButton
